export type Estado = 'marcado' | 'confirmado' | 'realizado' | 'faltou' | 'cancelado';
export type TipoRecurso = 'profissional' | 'sala' | 'equipamento';
export type Cor = 'acento' | 'roxo' | 'azul' | 'ciano' | 'laranja' | 'dourado' | 'sucesso';
export type Horario = Partial<Record<'1' | '2' | '3' | '4' | '5' | '6' | '7', [string, string][]>>;

export const CORES: Cor[] = ['acento', 'roxo', 'azul', 'ciano', 'laranja', 'dourado', 'sucesso'];
export const TIPOS: TipoRecurso[] = ['profissional', 'sala', 'equipamento'];
export const DIAS = ['1', '2', '3', '4', '5', '6', '7'] as const;

export interface Recurso {
  id: string;
  tipo: TipoRecurso;
  nome: string;
  usuario_id: string | null;
  usuario: string | null;
  cor: Cor;
  horario: Horario;
  descricao: string | null;
  ativo: boolean;
  bloqueios: { id: string; inicio: string; fim: string; motivo: string | null }[];
  proximos: number;
}

export interface Servico {
  id: string;
  nome: string;
  descricao: string | null;
  duracao_min: number;
  preco_centavos: string;
  moeda: string;
  cor: Cor;
  recursos: string[];
  recursos_nomes: string[];
  ativo: boolean;
  uso_30d: number;
}

export interface ItemAgenda {
  id: string;
  recurso_id: string;
  recurso: string;
  cor: Cor;
  servico: string | null;
  parceiro: string | null;
  titulo: string;
  inicio: string;
  fim: string;
  estado: Estado;
  origem: string;
  serie_id: string | null;
}

export interface Externo {
  id: string;
  titulo: string;
  tipo: string;
  inicio: string;
  fim: string;
  responsavel: string | null;
  concluido: boolean;
}

export interface Bloqueio {
  id: string;
  recurso_id: string;
  recurso: string;
  inicio: string;
  fim: string;
  motivo: string | null;
}

export interface Calendario {
  agendamentos: ItemAgenda[];
  bloqueios: Bloqueio[];
  externos: Externo[];
}

export interface Ficha extends ItemAgenda {
  servico_id: string | null;
  parceiro_id: string | null;
  observacoes: string | null;
  preco_centavos: string | null;
  moeda: string;
  motivo_cancelamento: string | null;
  serie_total: number;
  lembretes: { janela: string; resultado: string; em: string }[];
  /** campos personalizados de agenda.agendamento (SPEC-BASE-R29-01) */
  extras?: Record<string, unknown>;
}

export interface Config {
  lembretes_ativos: boolean;
  lembretes_horas: number[];
  lembrete_template: string;
  lembrete_idioma: string;
  google_recurso_id: string | null;
  google_ultima_sync: string | null;
  whatsapp: { estado: string };
  google: { habilitado: boolean; estado: string; calendario_id: string | null };
}

export const BOTAO_PRIMARIO = 'h-10 rounded-lg bg-acento px-4 text-sm font-medium text-acento-tinta hover:bg-acento-forte disabled:opacity-50';
export const BOTAO_SECUNDARIO = 'inline-flex h-9 items-center gap-1.5 rounded-lg border border-borda px-3 text-sm hover:bg-sup-2 disabled:opacity-50';

/** Cor do selo de estado (classe de token). */
export const COR_ESTADO: Record<Estado, string> = {
  marcado: 'bg-acento-suave text-tinta-1',
  confirmado: 'bg-sucesso/15 text-sucesso',
  realizado: 'bg-azul/15 text-azul',
  faltou: 'bg-laranja/15 text-laranja',
  cancelado: 'bg-sup-3 text-tinta-3',
};

/** Ponto de cor do recurso. */
export const PONTO: Record<Cor, string> = {
  acento: 'bg-acento',
  roxo: 'bg-roxo',
  azul: 'bg-azul',
  ciano: 'bg-ciano',
  laranja: 'bg-laranja',
  dourado: 'bg-dourado',
  sucesso: 'bg-sucesso',
};
